export default __webpack_public_path__ + "static/darkVectorMobile-812b950ade15b8485bb61a859fb3586a.png";